import React, { useEffect, useState } from "react";
import { Table, Button, Typography, Divider, Modal } from "antd";
import { useDispatch, useSelector } from "react-redux";

import "../allStudent/allstudent.css";
import Alert from "../../../components/common/alert";
import { SecurePost } from "../../../services/axiosCall";
import apis from "../../../services/Apis";
import CrossIcon from "../../../assets/crossIcon.svg";
import { fetchAllActiveOrders } from "../../../features/adminAsync";
import { InfoCircleOutlined } from "@ant-design/icons";
const AllActiveOrder = () => {
  const dispatch = useDispatch();
  const { loading, activeOrders } = useSelector((state) => state.orders);
  // console.log("Orders",activeOrders);
  

  const [isInfo, setIsInfo] = useState(false);
  const [activeObject, setActiveObject] = useState(null);
  const [reFetch, setReFetch] = useState(false);

  const handleDeliverOrder = async () => {
    try {
      const response = await SecurePost({
        url: apis.STATUS_ORDER_REWARD,
        data: {
          deliverDate: new Date(),
          rewardHistoryId: activeObject._id,
        },
      });

      if (response.data.message) {
        Alert("success", "Success", response.data.message);
        setReFetch(!reFetch);
        setIsInfo(false);
      } else {
        Alert("warning", "Warning!", response.data.message);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      Alert("error", "Error!", message);
    }
  };

  useEffect(() => {
    dispatch(fetchAllActiveOrders());
  }, [reFetch, dispatch]);

  const { Title } = Typography;

  const columns = [
    {
      title: <span style={{ color: "black" }}>Name</span>,
      dataIndex: "userId",
      key: "userId",
      render: (key, obj) =>
        <span style={{ color: "black" }}>{obj?.userId?.name || "N/A"}</span>,
    },
    {
      title: <span style={{ color: "black" }}>Order name</span>,
      dataIndex: "rewardId",
      key: "rewardId",
      render: (key, obj) =>
        <span style={{ color: "black" }}>{obj?.rewardId?.name || "N/A"}</span>,
    },
    {
      title: <span style={{ color: "black" }}>Category</span>,
      dataIndex: "rewardId",
      key: "category",
      render: (key, obj) =>
        (
          <span style={{ color: "black" }}>
            {obj?.rewardId?.categoryId?.name || "N/A"}
          </span>
        ),
    },
    {
      title: <span style={{ color: "black" }}>Invoice Number</span>,
      dataIndex: "invoiceNumber",
      key: "invoiceNumber",
      render: (text) => <span style={{ color: "black" }}>{text}</span> || "N/A",
    },
    {
      title: <span style={{ color: "black" }}>Date Ordered</span>,
      dataIndex: "date",
      key: "date",
      render: (text) =>
        (
          <span style={{ color: "black" }}>{`${
            new Date(text).getMonth() + 1
          }/${new Date(text).getDate()}/${new Date(text).getFullYear()}`}</span>
        ) || "N/A",
    },
    {
      title: <span style={{ color: "black" }}>Action</span>,
      key: "action",
      render: (_, obj) => (
        <>
          <Button
            type="primary"
            shape="circle"
            icon={<InfoCircleOutlined />}
            onClick={() => {
              setActiveObject(obj);
              setIsInfo(true);
            }}
          />
          <Divider type="vertical" />
        </>
      ),
    },
  ];

  return (
    <>
      <div className="admin-table-container">
        <div className="register-trainer-form-header">
          <Title level={4} style={{ color: "#fff", textAlign: "center" }}>
            Active Orders
          </Title>
        </div>

        <Table
          bordered
          columns={columns}
          dataSource={activeOrders}
          pagination={{ pageSize: 10 }}
          loading={loading}
          rowKey="_id"
          style={{ backgroundColor: "#fff", padding: "10px" }}
        />
      </div>

      <Modal
        open={isInfo}
        footer={null}
        closable={false}
        onCancel={() => setIsInfo(false)}
        className="rewardMModalAdmin"
        width={350}
        style={{ top: "30%", borderRadius: "25px", backgroundColor: "#fff" }}
      >
        {activeObject && (
          <div className="rewardModalContent">
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <img
                src={CrossIcon}
                alt="close"
                style={{ cursor: "pointer" }}
                onClick={() => setIsInfo(false)}
              />
            </div>
            <Typography
              style={{ padding: 0, marginTop: 3 }}
              className="cretaCateText"
            >
              Invoice Number: {activeObject.invoiceNumber}
            </Typography>
            <Typography>Customer Name: {activeObject.userId?.name} </Typography>
            <Typography>Name: {activeObject.rewardId?.name}</Typography>
            <Typography>
              Date Ordered:{" "}
              {`${new Date(activeObject.date).getMonth() + 1}/${new Date(
                activeObject.date
              ).getDate()}/${new Date(activeObject.date).getFullYear()}`}
            </Typography>
            <Typography>Order Cost: {activeObject.rewardId?.cost}</Typography>

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "30px",
              }}
            >
              <Button
                style={{ width: "120px", borderRadius: "60px" }}
                type="primary"
                onClick={handleDeliverOrder}
              >
                Deliver Order
              </Button>
            </div>
          </div>
        )}
      </Modal>
    </>
  );
};

export default AllActiveOrder;
